import React, { useState } from 'react';
import { DrawerHeader, ModalProps } from '@features/Modal';
import { IBmoTransaction } from '@shared/api';
import { Steps } from '@features/Steps';
import { GeneralInfo } from './components';
import { HandleRefresh } from '@shared/react/hooks/useAsyncData/interfaces';
import { patchTransactions } from '../../api';
import './BmoTransactionsViewDrawer.scss';

interface IBmoTransactionViewModalProps extends ModalProps {
    bmoTransaction: IBmoTransaction;
    bmoTransactionsRefresh?: HandleRefresh;
}

export const BmoTransactionsViewDrawer: React.FC<IBmoTransactionViewModalProps> = (props) => {
    const { bmoTransaction, onClose, bmoTransactionsRefresh } = props;

    const [editedValues, setEditedValues] = useState<IBmoTransaction>(bmoTransaction);

    const updateBmoTransaction = async () => {
        await patchTransactions({ id: bmoTransaction.id, body: editedValues });
        bmoTransactionsRefresh?.();
        onClose?.();
    };

    const bmoTransactionSteps = [
        {
            step: (
                <GeneralInfo
                    updateBmoTransaction={updateBmoTransaction}
                    editedValues={editedValues}
                    setEditedValues={setEditedValues}
                />
            ),
            title: 'General',
        },
    ];

    return (
        <div className='widget-bmo-transaction-view-drawer'>
            <DrawerHeader headerTitle={`Transaction ID: ${bmoTransaction.id}`} />
            <Steps
                footerClassName='widget-bmo-transaction-view-drawer__footer'
                headerClassName='widget-bmo-transaction-view-drawer__header'
                className='widget-bmo-transaction-view-drawer__steps'
                headerStepLabelClassName='widget-bmo-transaction-view-drawer__header-step-label'
                headerStepLineClassName='widget-bmo-transaction-view-drawer__header-step-line'
                titles={bmoTransactionSteps.map((item) => item.title)}
                footerVisible={false}
            >
                {bmoTransactionSteps.map((item) => item.step)}
            </Steps>
        </div>
    );
};
